import React from 'react';
import StatusBadge from './StatusBadge';
import ActivationKeyLink from './ActivationKeyLink';
import EnableLink from './Enable/Link'

const Menu = ({ activationKey, isActive, id }) => (
    <div className="dropdown">
        <a className="btn btn-sm btn-icon-only text-light"
            href="#"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
        >
            <i className="fas fa-ellipsis-v" />
        </a>
        <div className="dropdown-menu dropdown-menu-right dropdown-menu-arrow">
            <ActivationKeyLink activationKey={activationKey} />
            <EnableLink isActive={isActive} id={id} />
            {/* <Link className="dropdown-item" id={id} to="/">Reportar Problema</Link> */}
        </div>
    </div>
);

const TableRow = (props) => {
    const { activationKey, id, logicalNumber, establishment, name, pinpad, isActive } = props;
    const { model, serialNumber } = pinpad;
    const { brand } = model;
    return (
        <tbody>
            <tr>
                <th scope="row">
                    <img
                        alt={`${brand} ${model.model}`}
                        width="50px"
                        src="https://www.gertec.com.br/wp-content/uploads/2017/05/ppc910_img06.png"
                    />
                    {brand} {model.model}
                </th>
                <td>{name}</td>
                <td>{logicalNumber}</td>
                <td>{serialNumber}</td>
                <td>{establishment.title}</td>
                <td>
                    <StatusBadge status={isActive} />
                </td>
                <td className="text-right">
                  <Menu
                    activationKey={activationKey}
                    isActive={isActive}
                    id={id}
                  />
                </td>
            </tr>
        </tbody>
    );
}

export default TableRow;



// WEBPACK FOOTER //
// ./src/components/Pages/Terminals/TableRow.js